export default function(text, key, value) {
  if (value) {
    return text.replace(key, value);
  } else {
    return text.replace(key, '');
  }
}
